module.exports = __webpack_public_path__ + "static/media/splash-screen-background-image-with-logo.fb534379.png";